import {
  BooleanField,
  Field,
  NumberField,
  StringField,
} from '../../util/components/resource/resource-fields';
import { Activity } from '../activity/activity.model';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { Staff } from '../staff/staff.model';
import { ContractType } from './lib/contract.interfaces';

@Endpoint('contracts', 'Contract')
export class Contract extends ApiResource<Contract> {
  @Field({ type: () => ContractType, label: $localize`Type` })
  type!: ContractType;

  @StringField({ label: $localize`Document URL` })
  documentUrl?: string;

  @StringField({ label: $localize`Signed at` })
  signedAt!: Date | null;

  @StringField({ label: $localize`Signed at` })
  contractPaidAt!: Date | null;

  // This field doesn't exist on the backend anymore, but we still use it in
  // some places.
  hours!: number;

  @NumberField({ label: $localize`Hourly pay` })
  hourlyPay!: number;

  @BooleanField({ label: $localize`Payment approved` })
  paymentApproved!: boolean;

  @Field({ label: $localize`Staff`, type: () => Staff })
  staff!: Staff;

  @Field({
    includeFilter: false,
    type: () => Activity,
    label: $localize`Activity`,
  })
  activity!: Activity;
}
